import { fromPairs, map } from 'lodash/fp';
import React, { ReactNode } from 'react';
import { pipe } from 'ts-opt';
import { BreederRoleManagement } from 'api/gen/BreederRoleManagement';
import { UserProfileSubjectRoleManagementDtoBreederRoleManagement } from 'api/gen/UserProfileSubjectRoleManagementDtoBreederRoleManagement';
import { DynamicContent } from './gen-dynamic-content';
import { ManagementBreedersTableType } from '../../types/management-breeders';
import { getExpirationColor } from '../../utils/get-expiration-color';
const genDynamicColumns = (roles: Array<BreederRoleManagement>, computeFarmsTooltip: (ids: Array<number>) => string, onCellClick: (role: BreederRoleManagement) => void): Record<string, ReactNode> => pipe(roles, map(role => [role.roleId.toString(), <span key={role.roleId} className={getExpirationColor(role.bindingExpiration)}>
            <DynamicContent role={role} computeFarmsTooltip={computeFarmsTooltip} onCellClick={onCellClick} />
        </span>]), fromPairs);

/**
 * Maps breeder-management API rows into the tree-table representation.
 *
 * @param row Source API row with breeder access data and role bindings.
 * @param computeFarmsTooltip Callback used to build the farm tooltip text.
 * @param onCellClick Callback invoked when a role cell is activated.
 * @returns The breeder-management table row.
 *
 * @example
 * breedersRowMapper(row, computeFarmsTooltip, handleRoleClick);
 */
export const breedersRowMapper = (row: UserProfileSubjectRoleManagementDtoBreederRoleManagement, computeFarmsTooltip: (ids: Array<number>) => string, onCellClick: (role: BreederRoleManagement) => void): ManagementBreedersTableType => ({
  id: row.userProfileId,
  username: row.username,
  userProfileId: row.userProfileId,
  roles: row.roles,
  isSubjectMember: row.isSubjectMember,
  ...genDynamicColumns(row.roles, computeFarmsTooltip, onCellClick)
});